(function () {
  var root = document.querySelector('[data-rgoal]');
  if (!root) return;

  var LB_PER_KG = 2.20462;
  var CM_PER_IN = 2.54;
  var DAY_MS = 86400000;

  function nextWeekday(from, targetDay) {
    var d = new Date(from.getTime());
    d.setHours(0, 0, 0, 0);
    var diff = (targetDay - d.getDay() + 7) % 7;
    // setDate() instead of adding diff*DAY_MS: a fixed millisecond jump lands
    // an hour short of midnight on any day the span crosses a DST fall-back
    // (clocks gain an hour), which rounds down to the wrong calendar day —
    // confirmed live: a Wednesday start date mislabelled itself "Tuesday"
    // right across the Nov 1 2026 DST change. setDate() moves by calendar
    // day regardless of how many real hours that day actually has.
    d.setDate(d.getDate() + diff);
    return d;
  }

  // Order cutoff rule — must match reset-delivery-calendar.js's own
  // nextDeliveryDate() exactly (à la carte's version), since this was
  // confirmed live to have drifted from it in two separate ways: Wednesday
  // delivery's own cutoff day was wrong here (Sunday instead of the real
  // Saturday 11:59pm à la carte already uses), and the deadline comparison
  // used midnight of the cutoff day instead of its actual end (23:59:59.999)
  // — cutting the window off a full day earlier than intended, which is why
  // Goal Plan kept showing an already-expired date on Sundays specifically
  // (Wednesday's cutoff, wrongly set to Sunday midnight, had already passed
  // the moment Sunday began). Sunday delivery's own cutoff (Wednesday
  // 11:59pm) happened to already be correct.
  var deliveryDeadlineDow = { 0: 3, 3: 6 }; // sun(0)'s cutoff is wed(3) 11:59pm; wed(3)'s cutoff is sat(6) 11:59pm
  function nextValidWeekday(from, targetDay) {
    var target = nextWeekday(from, targetDay);
    var deadlineDow = deliveryDeadlineDow[targetDay];
    if (deadlineDow === undefined) return target;
    var backOffset = (targetDay - deadlineDow + 7) % 7;
    var deadline = new Date(target.getTime());
    deadline.setDate(deadline.getDate() - backOffset);
    deadline.setHours(23, 59, 59, 999);
    if (from.getTime() > deadline.getTime()) {
      target = new Date(target.getTime());
      target.setDate(target.getDate() + 7);
    }
    return target;
  }
  function formatDeliveryDate(d) {
    return d.toLocaleDateString('en-CA', { weekday: 'long', month: 'short', day: 'numeric' });
  }

  // The next Sunday/Wednesday that hasn't already missed its own order
  // cutoff — this has to match nextDateForWeekday() below exactly, since
  // one computes what's shown on the button and the other computes what's
  // sent at checkout.
  var deliveryDayLabels = { sun: 'Sunday', wed: 'Wednesday' };
  var nearestDeliveryDay = 'sun';
  (function computeDeliveryDates() {
    var now = new Date();
    var sunday = nextValidWeekday(now, 0);
    var wednesday = nextValidWeekday(now, 3);
    deliveryDayLabels.sun = formatDeliveryDate(sunday);
    deliveryDayLabels.wed = formatDeliveryDate(wednesday);
    nearestDeliveryDay = wednesday.getTime() < sunday.getTime() ? 'wed' : 'sun';

    Array.prototype.slice.call(root.querySelectorAll('[data-rgoal-yn="deliveryday"]')).forEach(function (group) {
      var buttons = Array.prototype.slice.call(group.querySelectorAll('[data-rgoal-day-label]'));
      buttons.forEach(function (btn) {
        var key = btn.dataset.rgoalDayLabel;
        if (deliveryDayLabels[key]) btn.textContent = deliveryDayLabels[key];
        btn.classList.toggle('is-active', key === nearestDeliveryDay);
      });
      // whichever date is chronologically nearest goes first (leftmost)
      var nearestBtn = buttons.filter(function (b) { return b.dataset.rgoalDayLabel === nearestDeliveryDay; })[0];
      if (nearestBtn && group.firstElementChild !== nearestBtn) {
        group.insertBefore(nearestBtn, group.firstElementChild);
      }
    });
  })();

  var plans = {};
  Array.prototype.slice.call(root.querySelectorAll('[data-rgoal-plan-json]')).forEach(function (el) {
    try { plans[el.dataset.rgoalPlanJson] = JSON.parse(el.textContent); } catch (e) {}
  });

  // The (up to) 3 real tag-based weeks the menu grid has data pre-rendered
  // for per plan — week0 (covers today), week1 (the soonest one after),
  // week2 (the one after that) — see reset-goal-plan.liquid. Each entry is
  // [start, end] as "YYYY-MM-DD" strings, or ["", ""] when nothing's synced
  // for that slot yet.
  var planWeeks = {};
  Array.prototype.slice.call(root.querySelectorAll('[data-rgoal-weeks]')).forEach(function (el) {
    try { planWeeks[el.dataset.rgoalWeeks] = JSON.parse(el.textContent); } catch (e) {}
  });

  // "checkout" used to be its own view/step (step 3) — removed entirely;
  // the checkout summary/button now live inside substep 2 of "customise"
  // itself, so there are only two views/steps left.
  var views = {
    browse: root.querySelector('[data-rgoal-view="browse"]'),
    customise: root.querySelector('[data-rgoal-view="customise"]')
  };

  var crumbExtra = root.querySelector('[data-rgoal-crumb-extra]');
  var stepPills = Array.prototype.slice.call(root.querySelectorAll('[data-rgoal-step-pill]'));
  var CRUMB_LABELS = { browse: '', customise: 'Customise' };
  var STEP_FOR_VIEW = { browse: '1', customise: '2' };
  // Swaps the page's big heading from whatever the merchant set (default
  // "Choose your plan") to "Customise your plan" once in step 2, same idea
  // as CRUMB_LABELS above — independent of the section setting's own text,
  // which is captured once here so switching back to browse restores it
  // exactly as configured rather than a hardcoded guess.
  var titleEl = root.querySelector('.rgoal__title');
  var titleDefaultText = titleEl ? titleEl.textContent : '';
  var TITLE_LABELS = { browse: titleDefaultText, customise: 'Customise your plan' };

  var state = {
    tdee: null,
    planValue: null,
    days: 5,
    deliveryDay: nearestDeliveryDay
  };

  function input(name) {
    return root.querySelector('[data-rgoal-input="' + name + '"]');
  }
  function num(el) {
    if (!el) return NaN;
    var v = parseFloat(el.value);
    return isNaN(v) ? NaN : v;
  }
  function money(n) {
    return '$' + Math.round(n).toLocaleString();
  }
  // Per-day amounts (weekly ÷ days) rarely land on a whole dollar — rounding
  // those the same way money() does would visibly misstate the real daily
  // rate (e.g. $119/6 days rounding to "$20" reads as $140/week, not $119).
  // Shown to the cent when it's genuinely not a whole number, but as a
  // plain whole dollar when it is (e.g. "$83/day", not "$83.00/day") —
  // the cents only matter when there actually are any.
  function moneyPerDay(n) {
    var rounded = Math.round(n * 100) / 100;
    var isWhole = rounded === Math.round(rounded);
    return '$' + (isWhole ? rounded.toFixed(0) : rounded.toFixed(2));
  }

  // While the offer is on, window.resetOffer is set by the offer side badge
  // (snippets/reset-offer.liquid). Then the per-day rate shows crossed out,
  // followed by the rate after the discount, taken off the weekly price the
  // way checkout does it (percent of the price, rounded to the cent).
  function perDayPriceHtml(weekly, perDay) {
    var offer = window.resetOffer;
    if (!offer || !(offer.percent > 0) || !(weekly > 0)) return moneyPerDay(perDay) + '/day';
    var cut = Math.round(weekly * offer.percent) / 100;
    var salePerDay = perDay * (weekly - cut) / weekly;
    return '<s><span class="visually-hidden">Regular price </span>' + moneyPerDay(perDay) + '</s> ' +
      '<span style="color:' + offer.saleColor + ';"><span class="visually-hidden">Sale price </span>' +
      moneyPerDay(salePerDay) + '</span>/day';
  }

  // Pushes a real history entry per view change (unless this call is itself
  // a response to one, via fromPopstate) so the browser's own Back button
  // steps back through browse -> customise first, instead of leaving the
  // page entirely on the very first Back press. Confirmed live as a real
  // bug: with no history entries of our own, this page was just one single
  // entry from the browser's point of view regardless of which internal
  // view was showing, so Back from "customise" skipped straight to whatever
  // page the customer was on before they ever landed here (e.g. à la carte).
  function showView(name, fromPopstate) {
    Object.keys(views).forEach(function (key) {
      if (views[key]) views[key].hidden = key !== name;
    });
    if (crumbExtra) crumbExtra.textContent = CRUMB_LABELS[name] || '';
    if (titleEl) titleEl.textContent = TITLE_LABELS[name] || titleDefaultText;
    var activeStep = STEP_FOR_VIEW[name];
    stepPills.forEach(function (pill) {
      pill.classList.toggle('is-active', pill.dataset.rgoalStepPill === activeStep);
    });
    root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    if (!fromPopstate) {
      try { history.pushState({ rgoalView: name }, '', location.href); } catch (err) {}
    }
  }

  try { history.replaceState({ rgoalView: 'browse' }, '', location.href); } catch (err) {}
  window.addEventListener('popstate', function (e) {
    var name = (e.state && e.state.rgoalView) || 'browse';
    if (!views[name]) name = 'browse';
    showView(name, true);
  });

  // ---- browse: filters ----
  var filterButtons = Array.prototype.slice.call(root.querySelectorAll('[data-rgoal-filter]'));
  var planCards = Array.prototype.slice.call(root.querySelectorAll('[data-rgoal-card]'));
  filterButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      filterButtons.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
      var val = btn.dataset.rgoalFilter;
      planCards.forEach(function (card) {
        card.hidden = val !== 'all' && card.dataset.rgoalCategory !== val;
      });
    });
  });

  // ---- browse -> customise ----
  var cpanels = Array.prototype.slice.call(root.querySelectorAll('[data-rgoal-cpanel]'));
  function openCustomise(planValue) {
    state.planValue = planValue;
    cpanels.forEach(function (p) { p.hidden = p.dataset.rgoalCpanel !== planValue; });
    var panel = root.querySelector('[data-rgoal-cpanel="' + planValue + '"]');
    if (panel) {
      var sub1 = panel.querySelector('[data-rgoal-substep="1"]');
      var sub2 = panel.querySelector('[data-rgoal-substep="2"]');
      if (sub1) sub1.hidden = false;
      if (sub2) sub2.hidden = true;
    }
    updatePricing();
    showView('customise');
  }
  root.querySelectorAll('[data-rgoal-customise-open]').forEach(function (btn) {
    btn.addEventListener('click', function () { openCustomise(btn.dataset.rgoalCustomiseOpen); });
  });
  root.querySelectorAll('[data-rgoal-back-to-browse]').forEach(function (btn) {
    btn.addEventListener('click', function () { showView('browse'); });
  });

  // ---- customise: tier / days / weeks ----
  function currentPanel() {
    return root.querySelector('[data-rgoal-cpanel="' + state.planValue + '"]');
  }

  function updatePricing() {
    var plan = plans[state.planValue];
    if (!plan) return;

    var weekly;
    var combo = findComboEntry(plan, state.days);
    if (combo && combo.price) {
      // Current billing model: every days combination is its own real,
      // single-price product (no variants, no calorie-tier dimension
      // anymore — each plan is now one fixed calorie range).
      weekly = combo.price;
    } else {
      var matched = findVariantEntryForSchedule(plan, state.days);
      if (matched && matched.price) {
        // Legacy fallback: one product with Days-only variants. Only used
        // for a combination that doesn't have its own connected product yet.
        weekly = matched.price;
      } else {
        // Nothing connected at all yet — placeholder fields.
        weekly = state.days === 6 ? plan.price6d : plan.price5d;
      }
    }

    var perDay = weekly / state.days;

    var panel = currentPanel();
    if (panel) {
      var weeklyEl = panel.querySelector('[data-rgoal-price-weekly]');
      var total2El = panel.querySelector('[data-rgoal-price-total-2]');
      var perDayHtml = perDayPriceHtml(weekly, perDay);
      if (weeklyEl) weeklyEl.innerHTML = perDayHtml;
      if (total2El) total2El.innerHTML = perDayHtml;
      applyDayVisibility(panel);
    }

    return { weekly: weekly };
  }

  function addDaysToIso(iso, delta) {
    var parts = iso.split('-').map(function (n) { return parseInt(n, 10); });
    var d = new Date(parts[0], parts[1] - 1, parts[2]);
    d.setDate(d.getDate() + delta);
    var mm = String(d.getMonth() + 1);
    if (mm.length < 2) mm = '0' + mm;
    var dd = String(d.getDate());
    if (dd.length < 2) dd = '0' + dd;
    return d.getFullYear() + '-' + mm + '-' + dd;
  }

  // Which of the (up to) 3 pre-rendered real weeks (see planWeeks above)
  // this exact delivery date actually belongs to. Each week's own start
  // (w[0], day1's Monday) has one fixed real order date: Sunday delivery
  // orders on the Sunday right *before* day1 (start - 1), Wednesday
  // delivery orders on day3's own Wednesday (start + 2) — not "any date
  // somewhere between start and end". Confirmed live as a real bug: the old
  // check only tested whether dateStr fell *anywhere* within [w[0], w[1]]
  // (inclusive of both ends), which matched a week whose actual order date
  // had already passed — the real selected date happened to still land
  // inside the raw start–end span — showing dishes and enabling checkout
  // for an order window that was no longer actually open. Same fix as
  // cardMatchesDay() in reset-menu.js, applied here too since this file has
  // its own separate (and until now separately broken) copy of this check.
  function resolveWeekIndex(planValue, dateStr, deliveryDay, days) {
    // Keyed by plan+days, not just plan — reset-goal-plan.liquid now renders
    // a separate week0/week1/week2 per days-option (see the comment above
    // collection_5d/collection_6d there), since Lean/Lite sync 5-day and
    // 6-day as two genuinely different collections with their own real
    // weekly menus now, not just "fewer days from the same shared one".
    var weeks = planWeeks[planValue + '-' + days];
    if (!weeks || !dateStr) return null;
    var offset = deliveryDay === 'wed' ? 2 : -1;
    var keys = ['w0', 'w1', 'w2'];
    for (var i = 0; i < keys.length; i++) {
      var w = weeks[keys[i]];
      if (w && w[0] && dateStr === addDaysToIso(w[0], offset)) return i;
    }
    return null;
  }

  // The real day-position -> week-index sequence a plan's chosen start date
  // actually delivers, in true chronological order. anchorWeek is which of
  // the pre-rendered weeks (0/1/2) actually contains the customer's real
  // selected start date — NOT necessarily "today's" week: the start-date
  // picker's own order-cutoff logic can bump the real date a full cycle
  // forward (e.g. if today itself is a Wednesday whose own cutoff already
  // passed, the real next Wednesday is next week, not this one), and the
  // days shown here have to follow that same real date, not just assume
  // "today" — that mismatch was confirmed live: the table was showing this
  // week's Thu/Fri/Sat when the customer's actual Wednesday start had
  // already rolled into next week's.
  //
  // Confirmed against every case the client gave: Sunday delivery = Mon-Wed
  // (day1-3), always within the anchor week itself; Wednesday delivery =
  // Thu-Sat (day4-6) normally, or just Thu-Fri for a 5-day plan (Saturday
  // always dropped from the Wednesday batch specifically) — rolling into
  // the following week's Mon/Tue/(Wed) to make up the rest.
  function buildDaySequence(deliveryDay, totalDays, anchorWeek) {
    var pos = deliveryDay === 'wed' ? 4 : 1;
    var week = anchorWeek;
    var seq = [];
    while (seq.length < totalDays) {
      if (pos > 6) {
        pos = 1;
        week = anchorWeek + 1;
      }
      if (pos === 6 && week === anchorWeek && deliveryDay === 'wed' && totalDays === 5) {
        pos++;
        continue;
      }
      seq.push({ pos: pos, week: week });
      pos++;
    }
    return seq;
  }

  // The menu grid is server-rendered with every day position (1-6) it could
  // possibly need, against week0/week1 (and week2 too for positions 1-3
  // only, per buildDaySequence() above), all hidden by default. This works
  // out the real anchor week from the customer's actual selected start date
  // (not just "today"), then shows + positions (via inline grid-column/
  // grid-row on desktop, DOM order + a plain hidden toggle on mobile)
  // exactly what buildDaySequence() says belongs on screen — instead of
  // always showing a fixed Monday-first block of "today's" week regardless
  // of what was picked, or assuming the customer's real date never rolls
  // past "today's" week. A day/week combination with nothing real behind
  // it still shows — the rgoal-meal-cell snippet renders "Not set yet" for
  // that itself, rather than this silently reusing the wrong week's dishes.
  function applyDayVisibility(panel) {
    var selectedDateStr = nextDateForWeekday(state.deliveryDay);
    var anchorWeek = resolveWeekIndex(state.planValue, selectedDateStr, state.deliveryDay, state.days);
    // Confirmed live: the delivery-day picker is pure calendar math (always
    // resolves to *some* real next Sunday/Wednesday), completely independent
    // of whether any menu has actually been synced for that date — so it
    // was letting a customer pick a date, see an all-"Not set yet" table,
    // and still reach checkout for it. state.hasNoMenuData records that gap
    // so goToCheckout() below can actually block ordering for it instead of
    // just displaying it honestly.
    state.hasNoMenuData = anchorWeek === null;
    // If the customer's actual selected date doesn't fall in any of the 3
    // known weeks, it means real synced data simply doesn't reach that far
    // out yet. Defaulting to week0 here used to be a real bug: week0 is
    // *today's* week, which almost always has real data — so it would
    // confidently show last week's dishes as if they were confirmed for a
    // date months away, which is worse than admitting we don't know yet.
    // week2 (the furthest-out bucket) is far more likely to genuinely be
    // blank in this situation, which is what correctly shows "Not set yet"
    // instead of quietly-wrong real dishes.
    if (anchorWeek === null) anchorWeek = 2;
    var sequence = buildDaySequence(state.deliveryDay, state.days, anchorWeek);

    // reset-goal-plan.liquid now renders a separate table for each
    // days-option, each wrapped in its own [data-rgoal-dayset="5"|"6"]
    // container (see the comment there) — only the one matching the
    // customer's current choice should ever be visible or operated on.
    // Querying the whole panel instead of just this container would hit
    // both copies at once, and panel.querySelector('.rgoal__stable') would
    // silently always grab the first (5-day) one regardless of which is
    // actually showing.
    var daysetEls = Array.prototype.slice.call(panel.querySelectorAll('[data-rgoal-dayset]'));
    var dayset = null;
    daysetEls.forEach(function (el) {
      var isActive = el.dataset.rgoalDayset === String(state.days);
      el.hidden = !isActive;
      if (isActive) dayset = el;
    });
    if (!dayset) return;

    dayset.querySelectorAll('.rgoal__stable-daylabel[data-rgoal-day]').forEach(function (el) {
      el.style.display = 'none';
    });
    dayset.querySelectorAll('.rgoal__stable-cell[data-rgoal-swapcell]').forEach(function (el) {
      el.style.display = 'none';
    });
    dayset.querySelectorAll('.rgoal__daylist-day[data-rgoal-day]').forEach(function (el) {
      el.style.display = 'none';
    });
    dayset.querySelectorAll('.rgoal__daylist-row-body[data-rgoal-swapcell]').forEach(function (el) {
      el.hidden = true;
    });

    sequence.forEach(function (entry, index) {
      var col = index + 2; // column 1 is the fixed 110px row-label column

      var label = dayset.querySelector('.rgoal__stable-daylabel[data-rgoal-day="' + entry.pos + '"]');
      if (label) {
        label.style.display = '';
        label.style.gridColumn = col;
        label.style.gridRow = 1;
      }

      dayset.querySelectorAll(
        '.rgoal__stable-cell[data-rgoal-day="' + entry.pos + '"][data-rgoal-week="' + entry.week + '"]'
      ).forEach(function (cell) {
        cell.style.display = '';
        cell.style.gridColumn = col;
        // each cell already carries its own fixed row (which meal slot it
        // is) from the Liquid side — only the column changes here
        cell.style.gridRow = cell.dataset.rgoalRow || '';
      });

      var daySection = dayset.querySelector('.rgoal__daylist-day[data-rgoal-day="' + entry.pos + '"]');
      if (daySection) {
        daySection.style.display = '';
        daySection.parentNode.appendChild(daySection); // reorder into sequence order
        daySection.querySelectorAll('.rgoal__daylist-row-body[data-rgoal-swapcell]').forEach(function (body) {
          // dataset values are always strings — entry.week is a number, so
          // this needs an explicit String() or the two never match
          if (body.dataset.rgoalWeek === String(entry.week)) body.hidden = false;
        });
      }
    });

    var stable = dayset.querySelector('.rgoal__stable');
    if (stable && sequence.length) {
      stable.style.gridTemplateColumns = '44px repeat(' + sequence.length + ', minmax(160px, 1fr))';
      stable.style.minWidth = (sequence.length * 160 + 44) + 'px';
    }
  }

  cpanels.forEach(function (panel) {
    panel.querySelectorAll('[data-rgoal-days]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        panel.querySelectorAll('[data-rgoal-days]').forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        state.days = parseInt(btn.dataset.rgoalDays, 10);
        updatePricing();
      });
    });
    // yes/no toggles
    panel.querySelectorAll('[data-rgoal-yn]').forEach(function (group) {
      var kind = group.dataset.rgoalYn;
      group.querySelectorAll('[data-rgoal-yn-val]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          group.querySelectorAll('[data-rgoal-yn-val]').forEach(function (b) { b.classList.toggle('is-active', b === btn); });
          var val = btn.dataset.rgoalYnVal;
          if (kind === 'deliveryday') {
            state.deliveryDay = val;
            // this is what the menu grid's day columns/sections are actually
            // keyed off (see buildDaySequence()) — previously nothing here
            // re-rendered it at all, so choosing Sunday vs Wednesday had no
            // visible effect on the picker below
            updatePricing();
          }
        });
      });
    });

    // menu swap: clicking an option in the dropdown updates the display
    // card's image/name/description, marks itself current (which hides it
    // from the open list via CSS — only the OTHER option(s) stay visible to
    // pick), updates the closed trigger's own text, and closes the dropdown.
    // The chosen option is read later by collectPlanChoices() (via
    // [data-rgoal-swap-opt].is-current and its data-index/data-recipe-id)
    // when building the checkout payload.
    panel.querySelectorAll('[data-rgoal-swapcell]').forEach(function (cell) {
      var dd = cell.querySelector('[data-rgoal-swap-dd]');
      var opts = Array.prototype.slice.call(cell.querySelectorAll('[data-rgoal-swap-opt]'));
      var display = cell.querySelector('[data-rgoal-swap-display]');
      if (!opts.length || !display) return;
      var media = display.querySelector('[data-rgoal-swap-media]');
      var nameEl = display.querySelector('[data-rgoal-swap-name]');
      var descEl = display.querySelector('[data-rgoal-swap-desc]');
      var allergensEl = display.querySelector('[data-rgoal-swap-allergens]');
      var dietsEl = display.querySelector('[data-rgoal-swap-diets]');
      var triggerText = dd ? dd.querySelector('[data-rgoal-swap-trigger-text]') : null;
      opts.forEach(function (opt) {
        opt.addEventListener('click', function () {
          if (opt.classList.contains('is-current')) return;
          opts.forEach(function (o) {
            var isThis = o === opt;
            o.classList.toggle('is-current', isThis);
            o.setAttribute('aria-pressed', isThis ? 'true' : 'false');
          });
          if (nameEl) nameEl.textContent = opt.dataset.name || '';
          if (descEl) descEl.textContent = opt.dataset.desc || '';
          if (allergensEl) allergensEl.textContent = opt.dataset.allergens || '';
          if (dietsEl) dietsEl.textContent = opt.dataset.diets || '';
          if (triggerText) triggerText.textContent = opt.dataset.name || '';
          if (media) {
            var url = opt.dataset.image;
            media.innerHTML = url ? '<img src="' + url + '" alt="' + (opt.dataset.name || '') + '" loading="lazy">' : '';
          }
          if (dd) dd.removeAttribute('open');
        });
      });
    });

    // substep nav — only two substeps now (step 3/the separate checkout
    // view was removed entirely; the "Test Real Checkout" button and its
    // summary live inside substep 2 itself), so entering substep 2 is also
    // the point where its checkout button/caption need to be freshly set,
    // which used to happen on a separate "Continue to Order Summary" click.
    var goto2 = panel.querySelector('[data-rgoal-goto-substep2]');
    var back1 = panel.querySelector('[data-rgoal-substep-back]');
    var sub1 = panel.querySelector('[data-rgoal-substep="1"]');
    var sub2 = panel.querySelector('[data-rgoal-substep="2"]');

    if (goto2) goto2.addEventListener('click', function () {
      if (sub1) sub1.hidden = true;
      if (sub2) sub2.hidden = false;
      updatePricing();

      var plan = plans[state.planValue];
      if (plan) {
        var deliveryDayLabel = deliveryDayLabels[state.deliveryDay] || deliveryDayLabels.sun;
        setTextIn(panel, '[data-rgoal-s2-plan]', plan.name);
        setTextIn(panel, '[data-rgoal-s2-deliveryday]', deliveryDayLabel);
      }
      goToCheckout();

      // Land on the actual meal table, not wherever the page happened to be
      // scrolled to on substep 1 (sub1/sub2 swap in place with no scroll of
      // their own, so without this the viewport just stayed put).
      var tableAnchor = panel.querySelector('[data-rgoal-table-anchor]');
      if (tableAnchor) tableAnchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    if (back1) back1.addEventListener('click', function () {
      if (sub2) sub2.hidden = true;
      if (sub1) sub1.hidden = false;
    });

    // hero image gallery
    var cheroImg = panel.querySelector('[data-rgoal-chero-img]');
    panel.querySelectorAll('[data-rgoal-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        panel.querySelectorAll('[data-rgoal-thumb]').forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
        if (cheroImg && thumb.dataset.full) cheroImg.src = thumb.dataset.full;
      });
    });

  });

  // ---- remove the selected plan entirely (from the cart too) and go back to browsing ----
  function notifyCartUpdate(itemCount) {
    try {
      var evt = new Event('shopify:cart:lines-update', { bubbles: true });
      evt.action = 'remove';
      evt.promise = Promise.resolve({ detail: { itemCount: itemCount } });
      document.dispatchEvent(evt);
    } catch (err) {}
  }

  // Finds a cart line by its real backend_plan_id property (the same one
  // reset-cart-plan-guard.js already uses to find/clean up a plan's $0
  // component lines) rather than remembering a variant id in JS memory,
  // since that memory is lost if the customer left for real checkout and
  // came back — the cart itself is the only reliable source of what's
  // actually in it. Previously checked a "Plan" property instead, which
  // never actually exists on a real backend-created line (confirmed live
  // by calling the checkout API directly and inspecting its real response)
  // — this silently never matched anything, so the button did nothing on a
  // genuine order. backend_fulfillment_only distinguishes the one real
  // paid line from that same plan's many $0 recipe lines, which
  // reset-cart-plan-guard.js's own polling cleans up right after this
  // removes the paid line (same split of responsibility it already uses).
  function removeGoalPlanFromCart(callback) {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var matchIndex = -1;
        (cart.items || []).forEach(function (item, i) {
          if (matchIndex !== -1) return;
          var props = item.properties || {};
          var planId = props.backend_plan_id || props._backend_plan_id;
          var fulfillmentOnly = props.backend_fulfillment_only === 'true' || props._backend_fulfillment_only === 'true';
          if (planId && !fulfillmentOnly) matchIndex = i;
        });
        if (matchIndex === -1) return null;
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: matchIndex + 1, quantity: 0 })
        }).then(function (res) { return res.json(); });
      })
      .then(function (cart) {
        if (cart) notifyCartUpdate(cart.item_count);
        if (callback) callback();
      })
      .catch(function () {
        if (callback) callback();
      });
  }

  // Purely cosmetic cover for the real network delay removeGoalPlanFromCart()
  // takes (a /cart.js read + a /cart/change.js write) — the owner's own
  // suggestion was "something funky, like a broom cleaning", explicitly
  // offered as a loose idea rather than a spec, so this builds on that
  // theme without being literal about it. One shared overlay (not one per
  // panel) since only one removal can ever be in flight at a time.
  var removingOverlay = null;
  function showRemovingOverlay() {
    if (removingOverlay) return;
    removingOverlay = document.createElement('div');
    removingOverlay.className = 'rgoal-removing-overlay';
    removingOverlay.innerHTML =
      '<div class="rgoal-removing-card">' +
        '<div class="rgoal-removing-broom" aria-hidden="true">' +
          '<span class="rgoal-removing-broom-emoji">🧹</span>' +
          '<span class="rgoal-removing-dust"></span>' +
          '<span class="rgoal-removing-dust"></span>' +
          '<span class="rgoal-removing-dust"></span>' +
        '</div>' +
        '<p>Clearing your plan…</p>' +
      '</div>';
    document.body.appendChild(removingOverlay);
  }
  function hideRemovingOverlay() {
    if (!removingOverlay) return;
    removingOverlay.remove();
    removingOverlay = null;
  }

  // One "Remove plan" button per plan panel now (it lives inside substep 2,
  // which is rendered once per plan block) — used to be a single shared
  // instance in the separate checkout view/step, queried with a plain
  // root.querySelector. A forEach over all of them, each with its own
  // click listener, replaces that; the handler body itself is unchanged.
  root.querySelectorAll('[data-rgoal-remove-plan]').forEach(function (removePlanBtn) {
    removePlanBtn.addEventListener('click', function () {
      removePlanBtn.disabled = true;
      showRemovingOverlay();
      removeGoalPlanFromCart(function () {
        removePlanBtn.disabled = false;
        hideRemovingOverlay();
      });

      var panel = currentPanel();
      if (panel) {
        panel.querySelectorAll('[data-rgoal-days]').forEach(function (b) {
          b.classList.toggle('is-active', b.dataset.rgoalDays === '5');
        });
        panel.querySelectorAll('[data-rgoal-yn]').forEach(function (group) {
          var kind = group.dataset.rgoalYn;
          var defaultVal = kind === 'deliveryday' ? nearestDeliveryDay : 'no';
          group.querySelectorAll('[data-rgoal-yn-val]').forEach(function (b) {
            b.classList.toggle('is-active', b.dataset.rgoalYnVal === defaultVal);
          });
        });
        panel.querySelectorAll('[data-rgoal-swapcell]').forEach(function (cell) {
          var defaultOpt = cell.querySelector('[data-rgoal-swap-opt][data-index="0"]');
          if (defaultOpt && !defaultOpt.classList.contains('is-current')) {
            defaultOpt.click();
          }
        });
      }

      state.planValue = null;
      state.days = 5;
      state.deliveryDay = nearestDeliveryDay;

      showView('browse');
    });
  });

  // Reads whichever swap dropdowns the customer actually changed away from
  // the default dish (index 0) and returns a FLAT map keyed exactly the way
  // the backend expects: "{backendPlanId}__{day}__{SLOT}" -> recipeId. Cells
  // left on the default are deliberately omitted — the backend already falls
  // back to that day/slot's own default recipe when no entry is sent, so
  // there's no need to (and no client-side recipeId to) send the primary
  // dish's choice explicitly. Only the visible layout (desktop table vs
  // mobile daylist) is read, since both render the same day/slot cells but
  // only one is on-screen at a time.
  // Exact key format: "day{service-day-number}__{meal-slot}", e.g.
  // "day1__BREAKFAST", "day4__SNACK_TWO" — no plan id in the key at all
  // (an old key here was "{backendPlanId}__{day}__{SLOT}", which never
  // matched anything on her end). The two snack slots are "SNACK_ONE"/
  // "SNACK_TWO" (spelled out) — this previously sent the numeral form
  // ("SNACK_1"/"SNACK_2") per an earlier instruction from Madiha, but her
  // backend's actual Prisma `MealSlot` enum (prisma/schema.prisma) is
  // spelled-out, and shopify-meal-plan-checkout.ts builds this exact key
  // straight from that enum value — confirmed directly from her repo
  // source, not assumed. A planChoices entry for a snack slot that uses
  // the numeral form never matches that key server-side, so the swap
  // silently falls back to the slot's own default recipe instead of
  // erroring — exactly the "still shows the default menu instead of the
  // selected swap" symptom reported, for snack slots specifically
  // (breakfast/lunch/dinner keys already matched literally either way).
  var RGOAL_CHOICE_SLOT_KEYS = {
    breakfast: 'BREAKFAST',
    'snack-one': 'SNACK_ONE',
    lunch: 'LUNCH',
    'snack-two': 'SNACK_TWO',
    dinner: 'DINNER'
  };
  function collectPlanChoices(panel, plan) {
    if (!plan) return null;
    var choices = {};
    var hasAny = false;
    panel.querySelectorAll('[data-rgoal-swapcell]').forEach(function (cell) {
      if (cell.offsetParent === null) return;
      var opt = cell.querySelector('[data-rgoal-swap-opt].is-current');
      if (!opt || opt.dataset.index === '0') return;
      var recipeId = opt.dataset.recipeId;
      if (!recipeId) return;
      var slotEnum = RGOAL_CHOICE_SLOT_KEYS[cell.dataset.rgoalSlot] || (cell.dataset.rgoalSlot || '').replace(/-/g, '_').toUpperCase();
      var key = 'day' + cell.dataset.rgoalDay + '__' + slotEnum;
      choices[key] = recipeId;
      hasAny = true;
    });
    return hasAny ? choices : null;
  }

  // ---- checkout summary (no longer its own view/step — step 3 was removed
  // entirely; this now just refreshes the "Test Real Checkout" button's
  // label/caption in place, inside substep 2, whenever the customer reaches
  // or changes something on it. Updates every matching button/caption
  // across all plan panels rather than a single captured element — cheap,
  // and only the currently-visible plan's copy is ever actually seen. ----
  var checkoutSummary = null;
  function goToCheckout() {
    var plan = plans[state.planValue];
    var pricing = updatePricing();
    if (!plan || !pricing) return;

    var deliveryDayLabel = deliveryDayLabels[state.deliveryDay] || deliveryDayLabels.sun;

    var hasExactMatch = !!(findComboEntry(plan, state.days) || findVariantForSchedule(plan, state.days));
    checkoutSummary = {
      'Plan': plan.name,
      'Plan start day': deliveryDayLabel,
      'backend_plan_code': findBackendPlanCode(plan, state.days),
      'requested_start_date': nextDateForWeekday(state.deliveryDay)
    };
    var planChoices = collectPlanChoices(currentPanel(), plan);
    if (planChoices && Object.keys(planChoices).length) checkoutSummary['plan_choices_json'] = JSON.stringify(planChoices);
    if (plan.includedMeals) checkoutSummary['Included meals'] = plan.includedMeals;
    checkoutSummary[hasExactMatch ? 'Weekly price' : 'Weekly price (placeholder item — not the real charge)'] = money(pricing.weekly);

    // The delivery-day toggle always resolves to *some* real Sunday/
    // Wednesday date, whether or not any menu has actually been synced for
    // it — confirmed live: a customer could reach checkout for a date whose
    // whole table just said "Not set yet". Blocking the button here (not
    // just showing the empty table honestly, which applyDayVisibility
    // already did) is what actually stops the order, not just admits the
    // gap.
    root.querySelectorAll('[data-rgoal-test-checkout]').forEach(function (btn) {
      btn.disabled = !!state.hasNoMenuData;
      btn.textContent = state.hasNoMenuData
        ? 'Menu not available for this date yet'
        : hasExactMatch ? 'Continue to Checkout →' : 'Test Real Checkout →';
    });
    root.querySelectorAll('[data-rgoal-checkout-caption]').forEach(function (caption) {
      caption.textContent = state.hasNoMenuData
        ? 'This delivery date hasn’t been published yet — please choose the other delivery day, or check back soon.'
        : hasExactMatch
          ? 'Adds this plan to your cart as a one-time purchase.'
          : 'Placeholder only — adds a stand-in product at its own price and sends you to Shopify’s real checkout, just to test the flow. Not the final plan price.';
    });
  }

  // Current billing model: each days combination is its own real,
  // single-price product (set per plan in the theme editor, under
  // "Billing products") — comboMap has one entry per days-combination
  // that's actually connected, each carrying that product's own variant/
  // price/selling plan/backend code directly. No calorie-tier dimension
  // any more — each plan is one fixed calorie range now.
  function findComboEntry(plan, days) {
    var combos = plan.comboMap || [];
    for (var i = 0; i < combos.length; i++) {
      if (combos[i].days === days) return combos[i];
    }
    return null;
  }

  // Legacy fallback (one product with Days-only variants) — only consulted
  // for a combination that doesn't have its own connected product yet.
  function findVariantEntryForSchedule(plan, days) {
    var map = plan.variantMap || [];
    for (var i = 0; i < map.length; i++) {
      if (map[i].days === days) return map[i];
    }
    return null;
  }
  function findVariantForSchedule(plan, days) {
    var entry = findVariantEntryForSchedule(plan, days);
    return entry ? entry.variantId : 0;
  }

  // Backend identifies which meal plan was purchased by this code. Prefers
  // the matched combo product's own "Backend Plan Code" metafield, then
  // falls back to the plan-level one (from the legacy single product), then
  // finally a variant SKU as a last resort.
  function findBackendPlanCode(plan, days) {
    var combo = findComboEntry(plan, days);
    if (combo && combo.backendPlanCode) return combo.backendPlanCode;
    if (plan.backendPlanCode) return plan.backendPlanCode;
    var entry = findVariantEntryForSchedule(plan, days);
    return (entry && entry.sku) || plan.productSku || '';
  }

  // The plan's delivery start day is chosen as a weekday (Sunday/Wednesday),
  // not a calendar date — this resolves it to the next real occurrence of
  // that weekday (today included, if today is a match) so backend gets an
  // actual date to split delivery cycles from.
  function nextDateForWeekday(dayKey) {
    var targetDow = { sun: 0, mon: 1, tue: 2, wed: 3, thu: 4, fri: 5, sat: 6 }[dayKey];
    if (targetDow === undefined) return '';
    var d = nextValidWeekday(new Date(), targetDow);
    var mm = String(d.getMonth() + 1);
    if (mm.length < 2) mm = '0' + mm;
    var dd = String(d.getDate());
    if (dd.length < 2) dd = '0' + dd;
    return d.getFullYear() + '-' + mm + '-' + dd;
  }

  // Human label for the billing line's own visible "Delivery Date" property
  // — same "Sunday, 21 Oct" / "Wednesday, 24 Oct" style reset-delivery-
  // calendar.js already shows for à la carte orders (same formatDate()
  // approach: toLocaleDateString with month/day only), kept separate here
  // since Goal Plan's own Sunday/Wednesday picker is a different widget
  // with no shared cart attribute to read this back from.
  function deliveryDateLabel(dayKey) {
    var targetDow = { sun: 0, wed: 3 }[dayKey];
    if (targetDow === undefined) return '';
    var d = nextValidWeekday(new Date(), targetDow);
    var dayName = dayKey === 'sun' ? 'Sunday' : 'Wednesday';
    return dayName + ', ' + d.toLocaleDateString('en-CA', { month: 'short', day: 'numeric' });
  }

  // ---- checkout: the backend decides the exact cart lines now, not the
  // theme. We send it the plan, start date, and any meal swaps; it replies
  // with the real paid plan line (its weekly rate) plus one $0 "component"
  // line per meal in that week, added purely so the backend can see what
  // was ordered and split it into the right delivery cycles. Every line is
  // added as a plain one-time purchase now — no selling plan is attached to
  // any of them (the owner had the subscription/recurring billing removed
  // from Goal Plan entirely; it's no longer "ongoing weekly", just a single
  // charge per order). ----
  var MEAL_PLAN_CHECKOUT_URL = 'https://reset-ashen-seven.vercel.app/api/integrations/public/meal-plan-checkout';

  // Same reasoning as removePlanBtn above — one "Test Real Checkout" button
  // per plan panel now that it lives inside substep 2 instead of the
  // removed separate checkout view/step, so this needs one listener per
  // button rather than a single root.querySelector.
  root.querySelectorAll('[data-rgoal-test-checkout]').forEach(function (testCheckoutBtn) {
    testCheckoutBtn.addEventListener('click', function () {
      // Backstop alongside the disabled attribute goToCheckout() sets —
      // same belt-and-suspenders reasoning as the floating minimum bar's
      // own checkout guard elsewhere in this theme, in case anything ever
      // lets a click through while the button should be inert (a stale
      // disabled state after a fast day-toggle flip, for instance).
      if (state.hasNoMenuData) {
        alert('This delivery date hasn’t been published yet — please choose the other delivery day, or check back soon.');
        return;
      }

      var plan = plans[state.planValue];
      if (!plan) return;

      var planCode = findBackendPlanCode(plan, state.days);
      if (!planCode) {
        alert('No backend plan code found for this combination — the connected product is missing its "Backend Plan Code" metafield.');
        return;
      }

      // Collected fresh, right here, right now — the swap table lives
      // inside substep 2 (reset-goal-plan.liquid), and this button is
      // itself part of substep 2, so by the time it's even clickable the
      // table is guaranteed visible. An earlier version of this cached the
      // choices at the goto2 click instead, on the wrong assumption that
      // the table lived in substep 1 — that captured a snapshot BEFORE
      // substep 2 (and the table) ever became visible, so it was always
      // empty, before the customer could have swapped anything at all.
      // Confirmed live: a genuine Saturday dinner swap still checked out
      // with the original default dish and is_swap_selection: false.
      var planChoices = collectPlanChoices(currentPanel(), plan) || {};

      var originalLabel = testCheckoutBtn.textContent;
      testCheckoutBtn.disabled = true;
      testCheckoutBtn.textContent = 'Adding to cart…';

      fetch(MEAL_PLAN_CHECKOUT_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          planCode: planCode,
          requestedStartDate: nextDateForWeekday(state.deliveryDay),
          quantity: 1,
          planChoices: planChoices
        })
      })
        .then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok) throw new Error(data.error || 'meal plan checkout request failed');
            return data;
          }, function () {
            // The backend occasionally hands back a plain error page instead
            // of JSON (a timeout, a gateway error, etc.) — res.json() throws
            // a raw "Unexpected token '<'" parse error in that case, which
            // isn't something a customer should ever see in the checkout
            // failure alert below.
            throw new Error('Something went wrong reaching checkout. Please try again in a moment.');
          });
        })
        .then(function (data) {
          var cartLines = data.cartLines || [];
          if (!cartLines.length) throw new Error('backend returned no cart lines');

          // A property name starting with "_" is hidden by Shopify from the
          // cart, checkout, and order emails automatically — still fully
          // present in the real order data, so nothing about the backend
          // integration changes, only what's visible to the customer.
          // backend_fulfillment_only/backend_plan_id/backend_plan_code/
          // requested_start_date/plan_choices_json were left visible until
          // now because the backend read them by their exact un-prefixed
          // name — confirmed with her that her order-reading code has been
          // updated to expect the underscored names, so these are now safe
          // to hide too.
          var HIDDEN_PROPERTY_KEYS = [
            'recipe_code', 'plan_day', 'meal_slot', 'service_date', 'cycle_date',
            'backend_fulfillment_only', 'backend_plan_id', 'backend_plan_code',
            'requested_start_date', 'plan_choices_json', 'is_swap_selection',
            // Older plans (Lite/Lean/Balance/Plus) come back from the same
            // backend endpoint with a different property set than Fuel's —
            // confirmed live, these were showing raw in the customer's cart
            // because the list above only ever covered Fuel's naming.
            'service_days_per_week', 'service_day', 'service_weekday', 'menu_day'
          ];
          function hidePrivateProperties(properties) {
            var out = {};
            Object.keys(properties || {}).forEach(function (key) {
              var outKey = HIDDEN_PROPERTY_KEYS.indexOf(key) !== -1 ? '_' + key : key;
              out[outKey] = properties[key];
            });
            return out;
          }

          // Shopify's /cart/add.js reverses an entire batch's order when it
          // stores the lines — confirmed directly against the live cart:
          // submitting items [a, b, c, ...] in that order lands in the cart
          // as [..., c, b, a] (fully reversed, not line-by-line, the whole
          // submitted list). So to land on [billing, comp1, comp2, ...] in
          // the actual cart, the array has to be sent here already reversed
          // — [..., comp2, comp1, billing] — which un-reverses back to the
          // intended order once Shopify stores it.
          var billingLines = cartLines.filter(function (line) {
            return !(line.properties && line.properties.backend_fulfillment_only === 'true');
          });
          var componentLines = cartLines.filter(function (line) {
            return line.properties && line.properties.backend_fulfillment_only === 'true';
          });
          var orderedCartLines = componentLines.slice().reverse().concat(billingLines);

          var deliveryDateLabelText = deliveryDateLabel(state.deliveryDay);
          var items = orderedCartLines.map(function (line) {
            var isBillingLine = !(line.properties && line.properties.backend_fulfillment_only === 'true');
            var lineProperties = hidePrivateProperties(line.properties);
            // Matches the same visible "Delivery Date" property à la carte
            // items already show in the cart drawer — only on the real
            // billing line, not on every $0 tracking line, since those
            // already carry the hidden (underscore-prefixed) backend dates.
            if (isBillingLine && deliveryDateLabelText) {
              lineProperties['Delivery Date'] = deliveryDateLabelText;
            }
            return {
              id: parseInt(line.ajaxVariantId, 10),
              quantity: line.quantity || 1,
              properties: lineProperties
            };
          });

          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: items })
          });
        })
        .then(function (res) {
          if (!res.ok) {
            return res.json().then(function (data) {
              throw new Error(data.description || data.message || 'add to cart failed');
            }, function () {
              throw new Error('add to cart failed');
            });
          }
          // This button used to jump straight to /checkout the instant
          // /cart/add.js succeeded, completely bypassing the site-wide $75
          // minimum / delivery-date-match rule reset-cart-minimum.js
          // enforces on every other checkout button — confirmed live: a
          // customer could add an under-minimum à la carte item on one
          // delivery day, then add a Goal Plan for a different day through
          // this button, and get sent straight to Shopify's real checkout
          // with no block and no explanation at all. Re-checking the exact
          // same rule here (via the shared helper reset-cart-minimum.js
          // exposes) and, when blocked, landing on /cart instead of
          // /checkout — not re-enabling this button to retry, which would
          // risk adding the same plan to the cart a second time — means
          // the customer lands exactly where the floating minimum bar
          // already explains why and what to do about it.
          return fetch('/cart.js', { cache: 'no-store' })
            .then(function (res2) { return res2.json(); })
            .then(function (cart) {
              // Defensive backstop: a line tagged backend_fulfillment_only
              // is meant to be $0 — the real charge is only ever the
              // billing line above it. If the backend's own recipe-to-
              // variant mapping is ever stale or missing for one dish (seen
              // live: one Fuel recipe had no $0 "component" product at all,
              // so the backend fell back to that recipe's real priced
              // à la carte variant instead), silently drop just that one
              // line here rather than let the customer get charged for it.
              // Self-corrects the moment the backend's mapping is fixed —
              // once every fulfillment-only line is genuinely $0, this
              // never finds anything to remove.
              var badLines = cart.items.filter(function (item) {
                return item.properties && item.properties._backend_fulfillment_only === 'true' && item.price !== 0;
              });
              if (!badLines.length) return cart;

              var updates = {};
              badLines.forEach(function (item) { updates[item.key] = 0; });
              return fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ updates: updates })
              }).then(function (res3) { return res3.json(); });
            })
            .then(function (cart) {
              notifyCartUpdate(cart.item_count);
              var blocked = window.ResetCartMinimum && window.ResetCartMinimum.isCheckoutBlocked(cart);
              window.location.href = blocked ? '/cart' : '/checkout';
            });
        })
        .catch(function (err) {
          testCheckoutBtn.disabled = false;
          testCheckoutBtn.textContent = originalLabel;
          // Surfaces the real reason (from the backend or from Shopify)
          // instead of a generic message, so it can actually be diagnosed.
          alert('Could not complete checkout: ' + (err && err.message ? err.message : 'unknown error'));
        });
    });
  });

  function setText(selector, value) {
    var el = root.querySelector(selector);
    if (el) el.textContent = value;
  }
  // scoped to a single panel — there's one substep-2 summary per plan, so a
  // root-wide query would risk matching a different (hidden) plan's copy
  function setTextIn(container, selector, value) {
    var el = container.querySelector(selector);
    if (el) el.textContent = value;
  }
  // ---- meal details modal ---- cards show title only now (no inline
  // description, per the owner); clicking one opens this shared modal
  // instead, filled in from that exact card's own current image/name/
  // description (already kept up to date by the swap-opt buttons' own click
  // listener above, so whichever option is currently selected is what
  // shows here too — no separate tracking needed).
  var mealModal = root.querySelector('[data-rgoal-meal-modal]');
  var mealModalMedia = root.querySelector('[data-rgoal-meal-modal-media]');
  var mealModalName = root.querySelector('[data-rgoal-meal-modal-name]');
  var mealModalDesc = root.querySelector('[data-rgoal-meal-modal-desc]');
  var mealModalDiets = root.querySelector('[data-rgoal-meal-modal-diets]');
  var mealModalAllergens = root.querySelector('[data-rgoal-meal-modal-allergens]');

  // Pipe-delimited list (rgoal-meal-cell.liquid) -> a row of plain badge
  // spans, same look as the à la carte card/product page's own allergen
  // and nutrition badges. Hides the whole row when there's nothing to show
  // instead of leaving an empty strip.
  function fillTagRow(container, pipeList) {
    if (!container) return;
    var values = (pipeList || '').split('|').map(function (s) { return s.trim(); }).filter(Boolean);
    container.innerHTML = '';
    if (!values.length) {
      container.hidden = true;
      return;
    }
    values.forEach(function (v) {
      var span = document.createElement('span');
      span.className = 'rgoal__meal-modal-tag';
      span.textContent = v;
      container.appendChild(span);
    });
    container.hidden = false;
  }

  // The small card/swap-button thumbnails this modal's media is copied from
  // are only ever requested at width:160 (rgoal-meal-cell.liquid) — fine at
  // thumbnail size, visibly blurry blown up to the modal's much larger
  // media area. Shopify's CDN resizes on request, so bumping the same URL's
  // own width param asks it for a genuinely higher-resolution file, not an
  // upscaled copy of the tiny one.
  function upsizeModalImage(container, width) {
    if (!container) return;
    var img = container.querySelector('img');
    if (!img) return;
    var bump = function (url) { return url.replace(/([?&]width=)\d+/i, '$1' + width); };
    if (img.src) img.src = bump(img.src);
    if (img.srcset) {
      img.srcset = img.srcset.split(',').map(function (part) { return bump(part.trim()); }).join(', ');
    }
  }

  function openMealModal(card) {
    if (!mealModal) return;
    var media = card.querySelector('[data-rgoal-swap-media]');
    var name = card.querySelector('[data-rgoal-swap-name]');
    var desc = card.querySelector('[data-rgoal-swap-desc]');
    var diets = card.querySelector('[data-rgoal-swap-diets]');
    var allergens = card.querySelector('[data-rgoal-swap-allergens]');
    if (mealModalMedia) {
      mealModalMedia.innerHTML = media ? media.innerHTML : '';
      upsizeModalImage(mealModalMedia, 900);
    }
    if (mealModalName) mealModalName.textContent = name ? name.textContent : '';
    if (mealModalDesc) mealModalDesc.textContent = desc ? desc.textContent : '';
    fillTagRow(mealModalDiets, diets ? diets.textContent : '');
    fillTagRow(mealModalAllergens, allergens ? allergens.textContent : '');
    mealModal.hidden = false;
  }

  root.querySelectorAll('[data-rgoal-meal-open]').forEach(function (card) {
    card.addEventListener('click', function () { openMealModal(card); });
    // role="button"/tabindex="0" on these cards (they're <div>s, not real
    // buttons) needs its own Enter/Space handling — native buttons get this
    // for free, these don't.
    card.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        openMealModal(card);
      }
    });
  });
  root.querySelectorAll('[data-rgoal-meal-modal-close]').forEach(function (el) {
    el.addEventListener('click', function () { if (mealModal) mealModal.hidden = true; });
  });

  // ---- calculator modal ----
  var modal = root.querySelector('[data-rgoal-modal]');
  var resultBox = root.querySelector('[data-rgoal-result]');
  var maintenanceEl = root.querySelector('[data-rgoal-maintenance]');
  var calcState = { sex: 'female', weightUnit: 'kg', heightUnit: 'cm', goal: 'maintain' };

  var ACTIVITY_LEVELS = [
    { multiplier: 1.2, name: 'Sedentary', desc: 'I spend most of my day sat down and rarely exercise.' },
    { multiplier: 1.375, name: 'Lightly active', desc: 'I exercise lightly, 1-3 days a week.' },
    { multiplier: 1.55, name: 'Moderately active', desc: 'I exercise moderately, 3-5 days a week.' },
    { multiplier: 1.725, name: 'Very active', desc: 'I exercise hard, 6-7 days a week.' }
  ];

  var GOAL_ADJUSTMENTS = { loss: -500, maintain: 0, gain: 500 };
  var GOAL_LABELS = {
    loss: 'Your daily calorie target (weight loss)',
    maintain: 'Your estimated maintenance calories',
    gain: 'Your daily calorie target (weight gain)'
  };

  root.querySelectorAll('[data-rgoal-goal]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      calcState.goal = btn.dataset.rgoalGoal;
      root.querySelectorAll('[data-rgoal-goal]').forEach(function (b) { b.classList.toggle('is-active', b === btn); });
      computeMaintenance();
    });
  });

  root.querySelectorAll('[data-rgoal-calc-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () { if (modal) modal.hidden = false; });
  });
  root.querySelectorAll('[data-rgoal-modal-close]').forEach(function (el) {
    el.addEventListener('click', function () { if (modal) modal.hidden = true; });
  });

  // ---- sex toggle ----
  root.querySelectorAll('[data-rgoal-sex]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      calcState.sex = btn.dataset.rgoalSex;
      root.querySelectorAll('[data-rgoal-sex]').forEach(function (b) { b.classList.toggle('is-active', b === btn); });
      computeMaintenance();
    });
  });

  // ---- weight unit toggle ----
  root.querySelectorAll('[data-rgoal-weight-unit]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var unit = btn.dataset.rgoalWeightUnit;
      if (unit === calcState.weightUnit) return;
      var el = input('weight');
      var val = num(el);
      if (!isNaN(val)) {
        el.value = unit === 'lb' ? (val * LB_PER_KG).toFixed(1) : (val / LB_PER_KG).toFixed(1);
      }
      calcState.weightUnit = unit;
      root.querySelectorAll('[data-rgoal-weight-unit]').forEach(function (b) { b.classList.toggle('is-active', b === btn); });
      computeMaintenance();
    });
  });

  // ---- height unit toggle (Ft = decimal feet, e.g. 5.75) ----
  root.querySelectorAll('[data-rgoal-height-unit]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var unit = btn.dataset.rgoalHeightUnit;
      if (unit === calcState.heightUnit) return;
      var el = input('height');
      var val = num(el);
      if (!isNaN(val)) {
        el.value = unit === 'ft' ? (val / CM_PER_IN / 12).toFixed(2) : (val * 12 * CM_PER_IN).toFixed(0);
      }
      calcState.heightUnit = unit;
      root.querySelectorAll('[data-rgoal-height-unit]').forEach(function (b) { b.classList.toggle('is-active', b === btn); });
      computeMaintenance();
    });
  });

  // ---- live recalculation on direct input (age, weight, height) ----
  ['age', 'weight', 'height'].forEach(function (name) {
    var el = input(name);
    if (el) el.addEventListener('input', function () { computeMaintenance(); });
  });

  // ---- activity slider ----
  var activitySlider = input('activity');
  var activityNameEl = root.querySelector('[data-rgoal-activity-name]');
  var activityDescEl = root.querySelector('[data-rgoal-activity-desc]');
  function renderActivityLevel() {
    var index = parseInt(activitySlider.value, 10);
    var level = ACTIVITY_LEVELS[index] || ACTIVITY_LEVELS[0];
    if (activityNameEl) activityNameEl.textContent = level.name;
    if (activityDescEl) activityDescEl.textContent = level.desc;
    var max = parseInt(activitySlider.max, 10) || (ACTIVITY_LEVELS.length - 1);
    activitySlider.style.setProperty('--rgoal-fill', (index / max) * 100 + '%');
  }
  if (activitySlider) {
    activitySlider.addEventListener('input', function () {
      renderActivityLevel();
      computeMaintenance();
    });
    renderActivityLevel();
  }

  function getMetrics() {
    var age = num(input('age'));
    var weightVal = num(input('weight'));
    var heightVal = num(input('height'));
    var weightKg = isNaN(weightVal) ? NaN : (calcState.weightUnit === 'lb' ? weightVal / LB_PER_KG : weightVal);
    var heightCm = isNaN(heightVal) ? NaN : (calcState.heightUnit === 'ft' ? heightVal * 12 * CM_PER_IN : heightVal);
    var activityLevel = ACTIVITY_LEVELS[parseInt(activitySlider ? activitySlider.value : 0, 10)] || ACTIVITY_LEVELS[0];
    return { age: age, sex: calcState.sex, activity: activityLevel.multiplier, weightKg: weightKg, heightCm: heightCm };
  }

  function bestMatchingPlan(tdee) {
    var best = null;
    var bestDiff = Infinity;
    Object.keys(plans).forEach(function (value) {
      var plan = plans[value];
      var mid = ((plan.calMin || 0) + (plan.calMax || 0)) / 2;
      var diff = Math.abs(tdee - mid);
      if (diff < bestDiff) {
        bestDiff = diff;
        best = { value: value, plan: plan };
      }
    });
    return best;
  }

  var recommendBox = root.querySelector('[data-rgoal-recommend]');
  var recommendNameEl = root.querySelector('[data-rgoal-recommend-name]');
  var recommendedPlanValue = null;

  function computeMaintenance() {
    var m = getMetrics();
    if (isNaN(m.age) || isNaN(m.weightKg) || isNaN(m.heightCm)) {
      if (resultBox) resultBox.hidden = true;
      state.tdee = null;
      return;
    }

    var bmr = m.sex === 'male'
      ? (10 * m.weightKg) + (6.25 * m.heightCm) - (5 * m.age) + 5
      : (10 * m.weightKg) + (6.25 * m.heightCm) - (5 * m.age) - 161;

    var tdee = bmr * m.activity;
    var adjustment = GOAL_ADJUSTMENTS[calcState.goal] || 0;
    var result = tdee + adjustment;

    // owner-set floor/ceiling per sex — men have no ceiling (3000 is just
    // where the "high" range starts, not a hard max), women are capped at
    // both ends
    var CALORIE_CAPS = {
      female: { min: 1100, max: 2600 },
      male: { min: 1400, max: Infinity }
    };
    var caps = CALORIE_CAPS[m.sex] || CALORIE_CAPS.female;
    result = Math.max(caps.min, Math.min(caps.max, result));
    state.tdee = result;

    var resultLabelEl = root.querySelector('[data-rgoal-result-label]');
    if (resultLabelEl) resultLabelEl.textContent = GOAL_LABELS[calcState.goal] || GOAL_LABELS.maintain;
    if (maintenanceEl) maintenanceEl.textContent = Math.round(state.tdee / 10) * 10;
    if (resultBox) resultBox.hidden = false;

    var match = bestMatchingPlan(state.tdee);
    if (match && recommendBox) {
      recommendedPlanValue = match.value;
      if (recommendNameEl) recommendNameEl.textContent = match.plan.name;
      recommendBox.hidden = false;
    } else if (recommendBox) {
      recommendBox.hidden = true;
    }
  }

  var recommendOpenBtn = root.querySelector('[data-rgoal-recommend-open]');
  if (recommendOpenBtn) {
    recommendOpenBtn.addEventListener('click', function () {
      if (!recommendedPlanValue) return;
      // No calorie tier to also pick any more (each plan is a single fixed
      // range now) — opening the plan already resolves its own price via
      // openCustomise() -> updatePricing().
      openCustomise(recommendedPlanValue);
      if (modal) modal.hidden = true;
    });
  }
})();
